import SkeletonCreator from "../../output/assets/skeletons/skeleton-creator.js";

class ThreeSkeletonCreator extends SkeletonCreator {
    create(bindMatrixArray, bones, inverses) {
        const bindMatrix = new THREE.Matrix4().fromArray(bindMatrixArray);

        const boneInverses = [];
        for (let i = 0; i < bones.length; i++) {
            const boneInv = new THREE.Matrix4().fromArray(inverses, i*16);
            boneInverses.push(boneInv);
        }

        return {
            bindMatrix,
            skeleton: new THREE.Skeleton(bones, boneInverses),
        };
    }

    dispose(skeleton) {}
}

export default ThreeSkeletonCreator;
